export { default as SeleccionRecepciones } from "./SeleccionRecepciones";
